const getOgTitle = (title, config) => {
  const {
    suffixDivider,
    suffixTitle
  } = config || {};
  let template = [suffixDivider, suffixTitle].filter((t) => !!t).join(" ");
  if (!template) {
    return title
  }

  return `${title} ${template}`
}

export {
  getOgTitle
}
